import { put, select, takeLatest, all } from 'redux-saga/effects';
import { notify } from '@mrlannigan/reapop';
import { sagaError } from 'helpers/handleGenericSagaError';
import apiAuthCall from 'helpers/apiAuthCall';

import { actions, sitesSummaryDataFetched, timeOfDayHeatMapFetched } from './duck';
import { sitesSummaryEndpoint, timeOfDayHeatMapEndpoint } from './selectors';

export function* fetchTimeOfDayHeatMap(api, action) {
    try {
        const result = yield apiAuthCall(
            action.getState(),
            [api, api.request],
            {
                method: 'get',
                url: yield select(timeOfDayHeatMapEndpoint, action.payload)
            }
        );

        yield put(timeOfDayHeatMapFetched(result.data));
    } catch (err) {
        yield put(notify({
            id: action.payload.transactionId,
            ...sagaError(err)
        }));
    }
}

export function* fetchSitesSummaryData(api, action) {
    try {
        const result = yield apiAuthCall(
            action.getState(),
            [api, api.request],
            {
                method: 'get',
                url: yield select(sitesSummaryEndpoint, action.payload)
            }
        );

        yield put(sitesSummaryDataFetched(result.data));
    } catch (err) {
        yield put(notify({
            id: action.payload.transactionOId,
            ...sagaError(err)
        }));
    }
}

export default function* ttdSaga({ api }) {
    yield all([
        takeLatest(actions.FETCH_TOD_HEATMAP, fetchTimeOfDayHeatMap, api),
        takeLatest(actions.FETCH_SITES_SUMMARY_DATA, fetchSitesSummaryData, api)
    ]);
}



// WEBPACK FOOTER //
// ./src/services/ttd/saga.js